import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { ReportPackageReportType } from "@common/types/reports/report-package";
import { AccountingReportType } from "@common/types/reports/report-type";

export const BASE_REPORT_PACKAGE_REPORT_TYPES: ReportPackageReportType[] = [
    AccountingReportType.PROFIT_LOSS,
    AccountingReportType.BALANCE_SHEET,
    AccountingReportType.EXPENSE_BY_VENDOR,
    AccountingReportType.CASH_FLOW_STATEMENT,
    AccountingReportType.TRIAL_BALANCE,
    AccountingReportType.GENERAL_LEDGER,
];

export const REPORT_PACKAGE_ACCRUAL_UNAVAILABLE_TOOLTIP =
    "Some selected entities have no accrual ledger.";

export function canSelectAccrualBasis({
    selectedEntityIds,
    accrualEntityIds,
    isLoading,
}: {
    selectedEntityIds: number[];
    accrualEntityIds: Set<number>;
    isLoading: boolean;
}): boolean {
    if (selectedEntityIds.length === 0 || isLoading) {
        return true;
    }
    return selectedEntityIds.every((entityId) =>
        accrualEntityIds.has(entityId),
    );
}

export function resolveReportPackageLedgerId({
    ledgersByEntityId,
    selectedEntityIds,
    basis,
    fallbackLedgerId,
}: {
    ledgersByEntityId:
        | Record<number, Array<{ id: string; basis: AccountingLedgerBasis }>>
        | undefined;
    selectedEntityIds: number[];
    basis: AccountingLedgerBasis;
    fallbackLedgerId?: string;
}): string | undefined {
    if (!ledgersByEntityId || selectedEntityIds.length === 0) {
        return fallbackLedgerId;
    }
    const matchingLedger = (ledgersByEntityId[selectedEntityIds[0]] ?? []).find(
        (ledger) => ledger.basis === basis,
    );
    return matchingLedger?.id ?? fallbackLedgerId;
}
